export default __webpack_public_path__ + "static/media/greenTheme-boy.7d67734f.svg";